import React from 'react';
import FormBuilderLib from 'schematik-forms/lib';

import ErrorSummary from 'pods/forms/components/structural/ErrorSummary';
import { useMemberContext } from 'core/sitecore/member';
import { getMemberTrackingProps } from 'core/sitecore/member/utility';
import cloneDeep from 'lodash/cloneDeep';
import {
	trackEvent as _trackEvent,
	ITrackEventProps,
	ITrackMemberProps,
} from 'core/analytics';

import validators from './_formBuilder.validators';
import components from './_formBuilder.components';
import actions from './_formBuilder.actions';

const FormBuilder = (props: any) => {
	// This is to enable using hook for the action configuration
	const memberData = useMemberContext();
	const memberTrackingProps: ITrackMemberProps = getMemberTrackingProps(
		memberData,
	);

	const _actions = cloneDeep(actions);

	_actions.trackEvent = ({ action }: any) => {
		const { data } = action;
		const eventProps: ITrackEventProps = {
			event_section: data.eventSection,
			event_type: data.eventType,
			event_title: data.eventTitle,
			event_label: data.eventLabel,
			event_trigger: data.eventTrigger,
			event_url: data.eventUrl,
			event_message: data.eventMessage,
		};

		_trackEvent({
			...eventProps,
			...memberTrackingProps,
		});
	};

	return (
		<FormBuilderLib
			configTimestamp={1}
			registeredComponents={components}
			registeredValidators={validators}
			registeredActions={_actions}
			renderErrorSummary={(props: any) => <ErrorSummary {...props} />}
			{...props}
		/>
	);
};

export default FormBuilder;
